import { ServiceRequestNewFormClientInfo, clientType } from './ServiceRequestNewFormClientInfo';
import { ServiceRequestNewFormProductInfo } from './ServiceRequestNewFormProductInfo';
import ServiceRequestNewFormService from './ServiceRequestNewFormService';
import loc from 'Templates/4tservice/components/service/request.new/.default/lang/ru.json';
import { CheckboxBlock } from '~/components/CheckboxBlock';
import { SelectBase } from '~/components/SelectBase';
import { InputBase_v2 } from '~/components/InputBase_v2';
import { currentDate, subDays } from '~/utils/date';
import { ServiceRequestNewFormPopularClients } from './ServiceRequestNewFormPopularClients';

const RepairType = {
	Pay: 'PAY',
	Warranty: 'WARRANTY',
}

const WorkType = {
	Repair: 'REPAIR',
	QualityCheck: 'QUALITY_CHECK',
}

const lang = (key) => loc[`s.r.n_${key}`];

export const ServiceRequestNewForm = {
	data: () => ({
		repairType: RepairType.Pay,
		enabledSaleDate: false,
		client: {},
		defect: null,
		appearance: null,
		equipment: null,
		devicePrice: null,
		warrantyNumber: null,
		saleDate: null,
		orderNumber: null,
		purchaseShop: null,
		workType: null,
		buyCountry: null,
		clientType: null,
	}),
	computed: {
		modeQualityCheckByWarranty: (vm) =>
			vm.workType === WorkType.QualityCheck &&
			vm.repairType === RepairType.Warranty,
		showPopularClients: (vm) => vm.clientType === clientType.Entity,
	},
	watch: {
		modeQualityCheckByWarranty: {
			handler: function(value) {
				this.enabledSaleDate = value
			},
		},
	},
	methods: {
		submit() {
			if (!this.$refs.form.checkValidity()) return

			const button = this.$refs.submit_button;
			const spinner = document.createElement('div');
			spinner.classList.add('spinner-border', 'spinner-border-sm');
			button.setAttribute('disabled', '');
			button.innerText = lang('CREATING') + ' ';
			button.append(spinner);

			this.$refs.form.submit();
		},
	},
	render() {
		return (
			<form
				class="service-request-new-form"
				method="post"
				enctype="multipart/form-data"
				vOn:submit_prevent={ this.submit }
				ref="form"
			>
				<div>
					<ServiceRequestNewFormService class="mb-6" />

					<ServiceRequestNewFormClientInfo
						initialClient={ this.client }
						ref="client"
						vOn:typeChange={(type) => this.clientType = type}
					/>

					<InputBase_v2
						class="mb-6"
						type="text"
						name="ORDER_NUM"
						label={ lang('ORDER_NUM') }
						vModel_trim={ this.orderNumber }
					/>

					<ServiceRequestNewFormProductInfo />

					<div class="row mb-6">
						<div class="col-6">
							<SelectBase
								label={ lang('WORK_TYPE') }
								required
								name="WORK_TYPE"
								value={ this.workType }
								vOn:change={ (event) => this.workType = event.currentTarget.value }
							>
								<option selected value="REPAIR">{ lang('REPAIR') }</option>
								<option value="QUALITY_CHECK">{ lang('QUALITY_CHECK') }</option>
							</SelectBase>
						</div>
						<div class="col-6">
							<SelectBase
								vOn:change={ ({ currentTarget }) => this.repairType = currentTarget.value }
								required
								name="REPAIR_TYPE"
								label={ lang('REPAIR_TYPE') }
							>
								<option selected={ this.repairType === 'PAY' } value="PAY">{ lang('PAY') }</option>
								<option value="WARRANTY">{ lang('WARRANTY') }</option>
							</SelectBase>
						</div>
					</div>

					{ this.repairType === 'WARRANTY' ? (
						<InputBase_v2
							class="mb-6"
							type="text"
							name="WARRANTY_NUMBER"
							autocomplete="off"
							label={ lang('WARRANTY_NUMBER') }
							vModel_trim={ this.warrantyNumber }
							required
							error-message="Укажите номер гарантийного талона"
						/>
					) : null }

					<InputBase_v2
						class="mb-6"
						type="textarea"
						required
						name="DEFECT"
						rows="5"
						autocomplete="off"
						label={ lang('DEFECT') }
						error-message="Заполните неисправность"
						vModel_trim={ this.defect }
					/>

					<InputBase_v2
						class="mb-6"
						type="textarea"
						required
						name="APPEARANCE"
						rows="5"
						autocomplete="off"
						label={ lang('APPEARANCE') }
						error-message="Заполните внешний вид"
						vModel_trim={ this.appearance }
					/>

					<InputBase_v2
						class="mb-6"
						type="textarea"
						required
						name="EQUIPMENT"
						rows="5"
						autocomplete="off"
						label={ lang('EQUIPMENT') }
						error-message="Заполните комплектацию"
						vModel_trim={ this.equipment }
					/>

					<label class="input-block mb-6">
						<input class="input-block__input" type="file" name="DOCUMENTS[]" multiple/>
						<span class="label input-block__label">{ lang('DOCUMENTS') }</span>
					</label>

					<label class="input-block mb-6">
						<input class="input-block__input" type="file" name="PHOTOS[]" multiple/>
						<span class="label input-block__label">{ lang('PHOTOS') }</span>
					</label>

					<div class="mb-6">
						<SelectBase
							vOn:change={({ currentTarget }) => this.buyCountry = currentTarget.value}
							required
							name="BUY_COUNTRY"
							label={lang('BUY_COUNTRY')}
						>
							<option value="RB">{lang('BELARUS')}</option>
							<option value="KZ">{lang('KAZAKHSTAN')}</option>
							<option selected={this.buyCountry === null} value="RU">{lang('RUSSIA')}</option>
						</SelectBase>
					</div>

					<div class="mb-6">
						<CheckboxBlock
							class="mb-6"
							label={ lang('SPECIFY_SALE_DATE') }
							checked={ this.enabledSaleDate }
							vOn:change={ ({ currentTarget }) => this.enabledSaleDate = currentTarget.checked }
							disabled={ this.modeQualityCheckByWarranty }
						/>

						{ this.enabledSaleDate ? (
							this.modeQualityCheckByWarranty ? (
								<InputBase_v2
									class="mb-6"
									type="date"
									name="SALE_DATE"
									max={ currentDate() }
									min={ subDays(currentDate(), 13) }
									label={ lang('SALE_DATE') }
									required
									vModel={ this.saleDate }
									help-message="Устройство принимается на проверку качества в первые 14 дней с даты продажи"
								/>
							) : (
								<InputBase_v2
									class="mb-6"
									type="date"
									name="SALE_DATE"
									max={ currentDate() }
									label={ lang('SALE_DATE') }
									required
									vModel={ this.saleDate }
									error-message="Укажите дату продажи"
								/>
							)
						) : null }
					</div>

					<InputBase_v2
						class="mb-6"
						type="number"
						name="DEVICE_PRICE"
						min="0"
						error-message="Заполните цену устройства по кассовому чеку"
						vModel_number={ this.devicePrice }
						label={ lang('DEVICE_PRICE') }
					/>

					<InputBase_v2
						class="mb-6"
						type="textarea"
						name="PURCHASE_SHOP"
						rows="5"
						autocomplete="off"
						label={ lang('PURCHASE_SHOP') }
						vModel_trim={ this.purchaseShop }
					/>

					<button ref="submit_button" class="button button_theme_secondary button_width_200" type="submit">
						{ lang('CREATE_REQUEST') }
					</button>
				</div>

				<div>
					{this.showPopularClients && (
						<ServiceRequestNewFormPopularClients
							vOn:click={(client) => {
								this.$refs.client.name = client.NAME
								this.$refs.client.phone = client.PHONE
								this.$refs.client.isNameLocked = true
							}}
						/>
					)}
				</div>

			</form>
		);
	}
}
